import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromStaticDataReducer from '../reducers';
import * as staticDataCountriesReducer from '../reducers/index';
import * as staticDataReducer from '../static-data.reducer';

//#region Static Data ROOT STATE
export const getAuthState = createFeatureSelector<staticDataReducer.State, staticDataReducer.StaticDataState>(
  staticDataReducer.staticDataFeatureKey
);
//#endregion

export const getStaticDataProductAnnualSwitchLimitsState = createSelector(
  getAuthState,
  state => state[fromStaticDataReducer.fromStaticDataProductAnnualSwitchLimitsReducer.productAnnualSwitchLimitsFeatureKey]
);

export const getStaticDataProductAnnualSwitchLimitsFailure = createSelector(
  getStaticDataProductAnnualSwitchLimitsState,
  staticDataCountriesReducer.fromStaticDataProductAnnualSwitchLimitsReducer.getProductAnnualSwitchLimitsFailure
);

export const getStaticDataProductAnnualSwitchLimitsResponse = createSelector(
  getStaticDataProductAnnualSwitchLimitsState,
  staticDataCountriesReducer.fromStaticDataProductAnnualSwitchLimitsReducer.getProductAnnualSwitchLimitsResponse
);

export const getStaticDataProductAnnualSwitchLimitsisLoaded = createSelector(
  getStaticDataProductAnnualSwitchLimitsState,
  staticDataCountriesReducer.fromStaticDataProductAnnualSwitchLimitsReducer.getProductAnnualSwitchLimitsIsLoaded
);
